import { FC, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSuccessfulUpdateSnackbar, useFailedUpdateSnackbar, LoadingIndicator, ApiError } from "../../../../Components/CoreLib/library";
import { DumpLineItemDto } from "../../../../dtos";
import { useLazyGetQuoteByIdQuery, useGetDumpLineItemByIdQuery, useUpdateDumpLineItemMutation } from "../../../../store/generated/generatedApi";
import { DumpLineItemForm } from "../../../../Components/Forms/QuoteForm/LineItemForms/DumpLineItem/DumpLineItemForm";


export const EditDumpLineItemView: FC = () => {
    const { quoteId, lineItemId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const { data, isLoading, error, refetch } = useGetDumpLineItemByIdQuery({ id: lineItemId! });
    const [updateDumpLineItem, { isSuccess, isError, reset }] = useUpdateDumpLineItemMutation();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [quote, quoteId, getQuote]);

    useSuccessfulUpdateSnackbar('Dump Line Item', isSuccess, () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedUpdateSnackbar('Dump Line Item', isError, reset);

    const handleSave = (values: DumpLineItemDto) => {
        updateDumpLineItem(values);
    };

    const handleCancel = () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate(`/quotes`);
        }
    };

    if (isLoading || isQuoteLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <DumpLineItemForm save={handleSave} cancel={handleCancel} initValues={data} quote={quote} />;
};
